module.exports = __webpack_public_path__ + "img/block-b-2-1.018d7425.jpg";